import {DrawerProps} from '@mantine/core';
import {PlatformDrawer} from '@flexinet/ui-components';
import {RecordForm} from '../forms/RecordForm';
import {BankAccount} from '../types';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: BankAccount,
        handleSubmit: (values: BankAccount) => void
    }) => {

    const title = record?.id ? 'Edit Bank Account' : 'Add Bank Account';

    const handleFormSubmit = async (values: BankAccount) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            size="xl"
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    );
};
